// Imports de classes internas
import Substancia from "./Substancia";

export class Antoine {

    componente: Substancia;
    unidadeTemperatura = "°C";
    unidadePressao = "kPa";

    A = 1;
    B = 1;
    C = 1;

    constructor(nome: string, formula: string) {
        this.componente = new Substancia(nome, formula);
    }

    setConstantes(a: number, b: number, c: number) {
        this.A = a;
        this.B = b;
        this.C = c;
    }

    calcularPressao(temperatura: number) {
        const pressao = Math.exp(this.A - this.B / (temperatura + this.C));
        return pressao;
    }

    calcularTemperatura(pressao: number) {
        const temperatura = this.B / (this.A - Math.log(pressao)) - this.C;
        return temperatura;
    }

}